import { useNavigate } from 'react-router';
export const HandleClose = () => {
    const navigate = useNavigate();
    
    const handleback = () => {
         navigate(-1);     
    }

    return (
        <div className="col-md-6">
        <button
        type="button"
        className="btn color-white w-100 rounded custom-btn-color-secondary"
        onClick={handleback}
        >
        Close
        </button>
       </div>    
    );
 // navigate(-1);
};